import cn from 'clsx';
import { FC } from 'react';

import Feedback from '../../Description/Feedback';

import s from './DefaultTotalAmount.module.scss';
import DefaultRightSide, { DefaultRightSideProps } from './RightSide/DefaultRightSide';
import DefaultSummaryBox, { DefaultSummaryBoxProps } from './SummaryBox/DefaultSummaryBox';
import DefaultTitle, { DefaultTitleProps } from './Title/DefaultTitle';

export interface DefaultTotalAmountProps extends DefaultTitleProps, DefaultRightSideProps, DefaultSummaryBoxProps {
  date?: string;
  infoText?: string;
  className?: string;
  onClick?: () => void;
}

const DefaultTotalAmount: FC<React.PropsWithChildren<React.PropsWithChildren<DefaultTotalAmountProps>>> = ({
  date,
  title,
  titleColor,
  titleIcon,
  amount,
  amountColor,
  infoText,
  rightBadge,
  rightIllust,
  rightListIcon,
  summaryText,
  summaryItems,
  className,
  onClick
}) => {
  return (
    <div
      className={cn(
        s.wrap,
        {
          [s.active as string]: onClick
        },
        className
      )}
      onClick={onClick}
    >
      <p className={s.date}>{date}</p>
      <div className={s.content}>
        <DefaultTitle title={title} titleColor={titleColor} titleIcon={titleIcon} amount={amount} amountColor={amountColor} />
        <DefaultRightSide rightBadge={rightBadge} rightIllust={rightIllust} rightListIcon={rightListIcon} />
      </div>

      {infoText && <Feedback text={infoText} status="info" hasStatusIcon hasBg={false} hasLinkIcon={false} />}

      {(summaryText || summaryItems?.length) && <DefaultSummaryBox summaryText={summaryText} summaryItems={summaryItems} />}
    </div>
  );
};

export default DefaultTotalAmount;
